var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVideo = function SvgIconVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.292 31.528"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-video",
    d: "M27.6 0H3.925A3.925 3.925 0 0 0 0 3.925V27.6a3.925 3.925 0 0 0 3.925 3.925H27.6a3.925 3.925 0 0 0 3.928-3.925V3.925A3.925 3.925 0 0 0 27.6 0Zm15.554 3.1-9 6.207v12.919l9 6.2a2.633 2.633 0 0 0 4.138-2.118V5.214A2.634 2.634 0 0 0 43.154 3.1Z",
    fill: "#fff"
  })));
};
export default SvgIconVideo;